'use strict';

define('componentLoaders/i18nComponentLoader',['context'], function (context) {

		// Wraps the default loader and Intercepts viewModel construction 
		function I18nComponentLoader(loader) {
				this.loader = loader;
		}

		// Loads a specified view model using the default loader
		I18nComponentLoader.prototype.loadViewModel = function (name, viewModelConfig, callback) {

				// Get component config
				this.loader.getConfig(name, this.getConfigCallback.bind(this, name, viewModelConfig, callback));
		};

		I18nComponentLoader.prototype.getConfigCallback = function (name, viewModelConfig, callback, config) {

				var i18n = config['i18n'];

				// if i18n is false, fallback to default loader
				if (i18n === false) {
						callback(null);
				} else {

						// if i18n has a value use that as the root module name, else use the name of the requested component
						var rootModuleName = typeof i18n === 'undefined' ? config.require : i18n;

						var moduleName = [rootModuleName, 'i18n', context.language.toLowerCase()].join('.');
						require([moduleName], this.loadModuleSuccess.bind(this, name, viewModelConfig, callback), this.loadModuleFail.bind(this, callback));
				}
		};

		// Success callback
		I18nComponentLoader.prototype.loadModuleSuccess = function (name, viewModelConfig, callback, module) {

				// Delegate to defaultLoader
				this.loader.loadViewModel(name, viewModelConfig, function (factory) {

						// Pass the wrapped factory method to knockout by invoking the callback
						callback(this.getFactoryFunction(factory, module));
				}.bind(this));
		};

		// Factory function for knockout to cache
		I18nComponentLoader.prototype.getFactoryFunction = function (originalFactoryFunction, content) {
				return function () {

						// Call original factory function to create the viewModel
						var result = originalFactoryFunction.apply(this, arguments);

						// Modify the view model
						result.content = content;

						// Return the modified ViewModel
						return result;
				};
		};

		// Failure callback
		I18nComponentLoader.prototype.loadModuleFail = function (callback, error) {

				// Module failed to load.
				var name = error.requireModules && error.requireModules[0];

				// Undefine the module to cleanup internal stuff in requireJS
				require.undef(name);

				// Pass the null to knockout so it moves on to the next candidate.
				callback(null);
		};

		return I18nComponentLoader;
});
